import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/reportes/ProductsConsignment';

import EntryMovementReport from './entryMovementReport';
import {resetStore} from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.reporte_consignacion,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(EntryMovementReport);
